<!-- 商标求购 -->
<template>
  <div class="development">
    <div class="main">
      <div class="content">
        <div class="main_box">
          <div class="table">
            <table>
              <thead>
                <tr>
                  <th>商标类别</th>
                  <th>价格预算</th>
                  <th style="width: 8%">标题字数</th>
                  <th style="width: 8%">标题结构</th>
                  <th style="width: 18%">求购需求说明</th>
                  <th style="width: 16%">案源时间</th>
                  <th style="width: 9%">QQ</th>
                  <th>审核状态</th>
                  <th style="width: 7%">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in tableData" :key="item.id">
                  <td>{{ item.trademark_category }}</td>
                  <td>{{ item.budget.title }}</td>
                  <td style="width: 8%">{{ item.wordCount.title }}</td>
                  <td style="width: 8%">{{ item.trademark_structure }}</td>
                  <td style="width: 18%" v-html="item.description"></td>
                  <td style="width: 16%">{{ item.create_time }}</td>
                  <td style="width: 9%">{{ item.user.qq }}</td>
                  <td>{{ getStatusText(item.status) }}</td>
                  <td class="edit" style="width: 7%" @click="handleEdit(item)">
                    编辑
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="paging">
            <!-- <div class="pagingLeft">
                            <span>每页</span>
                            <el-select v-model="pageSize" placeholder="请选择" @change="handleSizeChange">
                                <el-option v-for="item in pageSizesOptions" :key="item" :label="item" :value="item">
                                </el-option>
                            </el-select>
                            <span>条</span>
                        </div> -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="queryParams.page"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="queryParams.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMyTrademarkWantToBuy } from "../../api/userApi"; // 根据实际路径调整

export default {
  data() {
    return {
      tableData: [],
      total: 0,
      queryParams: {
        page: 1,
        limit: 10,
        status: "",
      },
      statusOptions: [
        { value: "", label: "全部" },
        { value: "0", label: "待审核" },
        { value: "1", label: "通过" },
        { value: "2", label: "驳回" },
      ],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      console.log(this.queryParams, "this.queryParams");

      getMyTrademarkWantToBuy(this.queryParams)
        .then((response) => {
          this.tableData = response.data;
          this.total = response.count;
        })
        .catch((error) => {
          console.error("获取商标求购数据失败:", error);
        });
    },
    handleSizeChange(val) {
      this.queryParams.limit = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchData();
    },
    getStatusText(status) {
      const statusMap = {
        0: "待审核",
        1: "通过",
        2: "驳回",
      };
      return statusMap[status] || "未知状态";
    },
    handleEdit(item) {
      // 跳转到编辑页面，并传递ID
      this.$router.push({
        path: "/memberCenter/publish-trademark-demand",
        query: { id: item.id },
      });
    },
  },
};
</script>

<style scoped lang="less">
.content {
  width: 100%;
  max-width: 87.5rem;
  margin: 0 auto;
  //   position: absolute;
}
.main {
  background: #f5f5f5;
  width: 100%;
  .main_box {
    width: 100%;
    // height: 1017px;
    background: #fff;
    border-radius: 10px;
    // padding: 15px 40px 35px 40px;
    .table {
      //   width: 100%;
      table {
        width: 100%;
        border-collapse: collapse; /* 合并单元格边框 */
        border-spacing: 0; /* 移除单元格之间的间距 */
        margin: 15px 0 35px 0;
        th,
        td {
          /* 强制不换行 */
          white-space: nowrap;
          /* 内容超出容器隐藏 */
          overflow: hidden;
          /* 使用省略号表示被隐藏的内容 */
          text-overflow: ellipsis;
          /* 设置最大宽度或固定宽度 */
          width: 11%; /* 根据实际情况调整 */
          /* 确保内容不会自动扩展td的宽度 */
          display: inline-block;
          /* 可选：设定一个固定高度，如果适用 */
          height: 50px; /* 根据实际情况调整 */
          line-height: 50px;
        }
        thead {
          border-radius: 5px;
          background: #175dc2;

          tr {
            height: 50px;
            th {
              // width: 10%;
              font-family: PingFang SC, PingFang SC;

              font-weight: 600;
              font-size: 14px;
              color: #ffffff;
            }
          }
        }
        tbody {
          tr:nth-child(odd) {
          }
          tr:nth-child(even) {
            background: #f2f4fe;
            border-radius: 5px;
          }
          tr {
            td {
              // height: 50px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #121212;
              // white-space: nowrap; /* 禁止文字换行 */
              // overflow: hidden; /* 超出部分隐藏 */
              // text-overflow: ellipsis;
            }
          }
          .edit {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #175dc2;
            cursor: pointer;
          }
        }
      }
    }
    .paging {
      display: flex;
      justify-content: flex-end;
      padding-right: 45px;
      margin-bottom: 18px;
    }
  }
}
</style>
